var _rect, _polygon, _polygon2, _path, _path2, _polyline, _path3, _line, _line2, _path4, _path5, _polygon3, _path6, _path7, _path8, _line3, _line4, _circle, _circle2, _path9, _circle3, _line5, _line6, _circle4, _path10, _circle5, _circle6, _path11, _path12, _line7, _line8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 146 146",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "001-business") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 145,
    height: 145,
    fill: "none"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "93.82 106.67 87.42 133.07 54.62 133.07 48.22 106.67 93.82 106.67",
    fill: "#ed9180"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "99.42 94.67 99.42 106.67 93.82 106.67 48.22 106.67 42.62 106.67 42.62 94.67 99.42 94.67",
    fill: "#ed9180"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.45,61.8A12.9,12.9,0,0,1,82.93,77.32,12.9,12.9,0,0,1,98.45,61.8Z",
    fill: "#7bd489"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.63,53.23a12.91,12.91,0,0,1,3.43,12.1A12.9,12.9,0,0,1,41.54,49.8,12.9,12.9,0,0,1,53.63,53.23Z",
    fill: "#7bd489"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "71.42 55.07 71.42 79.87 71.42 94.27",
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45,61.89a12.9,12.9,0,0,0,12.09,3.43A12.9,12.9,0,0,0,41.54,49.8,12.89,12.89,0,0,0,45,61.89Z",
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 57.02,
    y1: 65.47,
    x2: 71.42,
    y2: 79.87,
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 71.82,
    y1: 88.27,
    x2: 82.62,
    y2: 77.47,
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.77,68.43a12.87,12.87,0,0,1,10.8-3.66,13,13,0,0,0-.31-2.17A12.9,12.9,0,0,0,83.73,78.12a13,13,0,0,0,1.29.23A12.84,12.84,0,0,1,88.77,68.43Z",
    fill: "#a4e0b3",
    opacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.37,65.23a12.89,12.89,0,0,0-3.43,12.1A12.9,12.9,0,0,0,98.45,61.8,12.9,12.9,0,0,0,86.37,65.23Z",
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "49.02 107 55.42 134 59.42 134 53.02 107 49.02 107",
    fill: "#eeb8a9",
    opacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.82,106.67l-6.25,25.79a0.8,0.8,0,0,1-.78.61H55.25a0.8,0.8,0,0,1-.78-0.61l-6.25-25.79",
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47,99.8L99,98.27v-3.2H42.22v12h2.4V102.2A2.4,2.4,0,0,1,47,99.8Z",
    fill: "#eeb8a9",
    opacity: 0.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.22,106.67h-4.8a0.8,0.8,0,0,1-.8-0.8V95.47a0.8,0.8,0,0,1,.8-0.8h55.2a0.8,0.8,0,0,1,.8.8v10.4a0.8,0.8,0,0,1-.8.8H48.22Z",
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 100.49,
    y1: 84.53,
    x2: 103.69,
    y2: 87.73,
    fill: "none",
    stroke: "#b8b9ba",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 103.69,
    y1: 84.53,
    x2: 100.49,
    y2: 87.73,
    fill: "none",
    stroke: "#b8b9ba",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.82,
    cy: 91.74,
    r: 2,
    fill: "none",
    stroke: "#b8b9ba",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.42,
    cy: 101.99,
    r: 1.6,
    fill: "#b8b9ba"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.29,109.3l2.33-1.22a0.08,0.08,0,0,1,.12.08l-0.44,2.59,2,1.95-2.76.4-1.24,2.5L29,113.11l-2.6-.38a0.08,0.08,0,0,1,0-.14l1.88-1.84L27.81,108Z",
    fill: "#a8cbeb"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.2,
    cy: 119.22,
    r: 1.6,
    fill: "#b8b9ba"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 24,
    x2: 42,
    y2: 30,
    fill: "none",
    stroke: "#b8b9ba",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 27,
    x2: 39,
    y2: 27,
    fill: "none",
    stroke: "#b8b9ba",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.22,
    cy: 13.33,
    r: 1.6,
    fill: "#b8b9ba"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.82,15.75A19.32,19.32,0,1,1,52.5,35.07,19.32,19.32,0,0,1,71.82,15.75ZM86.1,35.07A14.28,14.28,0,1,0,71.82,49.35,14.28,14.28,0,0,0,86.1,35.07Z",
    fill: "#ffffff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.82,
    cy: 35.07,
    r: 14.28,
    fill: "#a8cbeb"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.82,
    cy: 35.07,
    r: 19.32,
    fill: "none",
    stroke: "#515f76",
    strokeMiterlimit: 10,
    strokeWidth: 2.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72,34.79A3.45,3.45,0,0,1,75.6,38a3.67,3.67,0,0,1-7.28,0",
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6,31.57a3.67,3.67,0,0,0-7.28,0A3.45,3.45,0,0,0,72,34.79",
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 26,
    x2: 73,
    y2: 28,
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 43,
    x2: 72,
    y2: 44,
    fill: "none",
    stroke: "#515f76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfit);
export default __webpack_public_path__ + "static/media/profit.776f1ab26f775e2eee047c407c79cccb.svg";
export { ForwardRef as ReactComponent };